import React, { Component, PropTypes } from 'react'
import { createHistory } from 'history'
import { useRouterHistory, Router } from 'react-router'
import { Provider as ReduxProvider } from 'react-redux'

// 0.14.9给pc端外部网站使用,引入react-tap-event-plugin会导致编译无法通过，
// 暂时用react版本号来做判断，特殊处理
if (React.version !== '0.14.9') {
  try {
    const injectTapEventPlugin = require('react-tap-event-plugin')
    injectTapEventPlugin()
  } catch (ex) {
    console.log('react-tap-event-plugin not found')
  }
}


export class Provider extends Component {
  static propTypes = {
    routes : PropTypes.object.isRequired,
    store  : PropTypes.object.isRequired
  }

  shouldComponentUpdate () {
    return false
  }

  render () {
    const { routes, store } = this.props

    const history = useRouterHistory(createHistory)({
      basename: __BASENAME__
    })

    return (
      <ReduxProvider store={store}>
        <Router history={history} children={routes} />
      </ReduxProvider>
    )
  }
}



// WEBPACK FOOTER //
// ../~/shared/src/components/Provider.js